<template>
  <v-container class="justify-center">
    <v-container v-if="loading" class="justify-center flex-column">
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
      <br />
      <v-progress-linear indeterminate color="orange"></v-progress-linear>
      <br />
    </v-container>
    <div></div>
    <div v-if="loading" class="d-flex justify-center mb-6">
      <p>warten Sie bitte einen Moment</p>
    </div>

    <v-snackbar
      v-if="error"
      :timeout="-1"
      :value="true"
      absolute
      bottom
      color="red"
      outlined
      centered
    >
      {{ this.error }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="error = null">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-container
      v-if="loading == false"
      class="d-flex flex-row al justify-center align-item-center"
    >
      <v-card class="mt-3">
        <GChart type="ColumnChart" :data="chartData" :options="chartOptions" />
      </v-card>
    </v-container>
  </v-container>
</template>
<script>
import { GChart } from "vue-google-charts";
export default {
  components: { GChart },
  created() {
    axios
      .get(`/forecast/diagramm`)
      .then((res) => {
        this.value = res.data.soll_daten;
        this.value2 = res.data.forecast_daten;

        this.fetch(res.data);
        this.loading = false;
      })
      .catch((error) => {
        console.log(error.response.data);
        this.error = error.response.data.message;
      });
  },
  methods: {
    fetch(data) {
      this.chartData = null;
      let array = [];
      array.push(["Years", "Soll-Daten", "ist-Daten"]);

      for (let i = 1; i <= this.years.length; i++) {
        let temp = [];
        temp.push(this.years[i - 1].toString());
        temp.push(data.soll_daten[i - 1]);
        temp.push(data.forecast_daten[i - 1]);
        array.push(temp);
      }
      this.chartData = array;
    },
  },
  computed: {
    years() {
      let year = new Date().getFullYear();
      let arr = [];
      for (let i = year - 3; i <= year; i++) {
        arr.push(i);
      }
      return arr;
    },
  },
  data() {
    return {
      chartData: [],
      chartOptions: {
        title: "Balkendiagramme von Arbeitsstunden aller Mitarbeiter/innen",
        animation: {
          duration: 1000,
          easing: "linear",
          startup: true,
        },
        axisTitlesPostion: "out",
        titlePosition: "out",
        titleTextStyle: {
          color: "#cf4800",
          fontSize: 16,
          bold: true,
          italic: true,
        },
        colors: ["063b47", "#cf4800"],

        legend: { position: "bottom", textStyle: { fontSize: 12 } },

        width: "1000",
        height: "500",
        chart: {
          title: "Vergleichen der Soll- und Ist-Daten von gesamten Mitarbeiter",
        },
        vAxis: {
          title: "Stunden",
          titleTextStyle: {
            fontSize: 14,
            bold: true,
            color: "#58575c",
          },
        },
        hAxis: {
          title: "letzte 4 Jahren",
          titleTextStyle: {
            fontSize: 14,
            bold: true,
            color: "#58575c",
          },
        },

        bars: "vertical",
      },
      loading: true,
      error: null,
      y: this.years,
    };
  },
};
</script>